import { Card, Typography, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container"
import CssBaseline from "@mui/material/CssBaseline";
import alert from '../images/alert.svg'
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';
import { Footer } from "../components/Footer";
export const PyamentFail = () => {


    return (
      <Container  component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        > 
      <Card sx={{ minWidth: '100wv', boxShadow:'0' }}>
      <CardActionArea>
        <CardContent sx={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>

          <Grid container sm={12}>
        <Box sx={{ display: 'flex', flexDirection:'column', alignItems: 'center', margin: '20px' }}>
        <Box>
         <img src={alert} alt='' height='80px' style={{margin:'20px'}}/>
         </Box>
         <Box>
         <Typography sx={{color: 'primary.main', margin: '20px'}} variant='h4'>
            Ops! Nosso sistema se comportou de forma inesperada :(
         </Typography>
         </Box>
         <Box>
         <Typography sx={{color: 'primary.main', margin: '20px'}} variant='h5'>
            Fique tranquilo que entraremos em contato
         </Typography>
         </Box>
        </Box>
        </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
        < Footer />
        </Box>
        </Container>
    )
}